import * as React from 'react';

function IconActionCheckLarge(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21.56L6.43996 16L4.54663 17.88L12 25.3334L28 9.33337L26.12 7.45337L12 21.56Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconActionCheckLarge;
